import { useShopI18n } from '../../i18n'

export const RedirectingToPaymentStep = () => {
  const { t } = useShopI18n()

  return (
    <section className="rounded-2xl border border-emerald-200 bg-emerald-50 p-5 shadow-sm" aria-live="polite">
      <h2 className="text-lg font-semibold text-emerald-900">{t('checkout.redirect.title')}</h2>
      <p className="mt-2 text-sm text-emerald-800">{t('checkout.redirect.description')}</p>
    </section>
  )
}
